import React, { useState, useContext, useEffect } from "react";
import ActiveCurrenciesContext from "../../providers/CurrencyProvider";
import classes from "../Table/Table.module.css";
import axios from "axios";
import ClipLoader from "react-spinners/ClipLoader";
import { Link } from "react-router-dom";
import GlobalContext from "../../providers/GlobalProvider";
import "./MapperSelector.css";
export default function MapperSelector() {
  const { mappers, defaultMapper, setDefaultMapper } =
    useContext(GlobalContext);
  const [selectedDb, setSelectedDb] = useState(defaultMapper);

  const handleSelectDb = (event) => {
    const selectedMapper = event.target.value;

    localStorage.setItem("LastSelectedMapper", JSON.stringify(selectedMapper));
    if (!selectedMapper) {
      throw new Error("Mapper not found");
    }

    setSelectedDb(selectedMapper);
    setDefaultMapper(selectedMapper);
    window.location.reload();
  };
  useEffect(() => {
    console.log(selectedDb);
  }, [selectedDb]);

  return (
    <div className="selectors">
      <select onChange={handleSelectDb} value={selectedDb}>
        <option disabled value="">
          Select an option
        </option>
        {mappers.map((dbOption) => (
          <option key={dbOption} value={dbOption}>
            {dbOption}
          </option>
        ))}
      </select>
    </div>
  );
}
